<template>
  <div>
    <draw-list
      :value="drawList"
      :selected.sync="selectedDrawList"
      :loading="loadingData"
      :search="search"
    />
    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedDrawList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedDrawList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="/multiproject/draws/create"
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import DrawList from '../components/DrawList'

export default {
  name: 'DrawListContainer',
  components: {
    AgFloatButtonContainer,
    AgConfirmDialog,
    DrawList,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    drawList: [],
    selectedDrawList: [],
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    removeMessage () {
      const count = this.selectedDrawList.length
      return this.$tc('multiproject.remove.message', count, { count })
    },
    hasDefaultDrawInSelected () {
      return this.selectedDrawList
        .some(draw => draw.defaultDraw)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'MultiprojectDrawList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.drawList = await Repositories.multiProject.draw.getList()
      this.loadingData = false
    },
    async removeSelected () {
      if (this.hasDefaultDrawInSelected) {
        const notification = this.$t('multiproject.remove.cantRemoveDefaultDraw')
        this.showErrorNotification(notification)
      }
      else {
        try {
          this.loadingRemove = true
          const count = this.selectedDrawList.length
          const idList = this.selectedDrawList.map(draw => draw.id)
          await Repositories.multiProject.draw.delete(idList)
          const notification = this.$tc('multiproject.remove.success', count, { count })
          this.showSuccessNotification(notification)
        }
        catch (error) {
          const notification = Repositories.parseErrorMessage(error)
          this.showErrorNotification(notification)
        }
        finally {
          this.loadingRemove = false
          this.selectedDrawList = []
          this.fetchData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
